import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {organizationSettingsActions} from "_actions";

export default function useGetTrendsOrganization(organizationTrendsId, enabled = true) {
    const dispatch = useDispatch();

    useEffect(() => {
        if (enabled && organizationTrendsId) {
            dispatch(organizationSettingsActions.fetchTrendsOrganization(organizationTrendsId));
        }
    }, [organizationTrendsId, enabled, dispatch]);

    const organizationSettings = useSelector(state => state.organizationSettings);

    return {
        trendsOrganization: organizationSettings.trendsOrganization || {},
        loading: organizationSettings.loadingTrendsOrganization,
        updatingField: organizationSettings.updatingTrendsOrganizationField,
    };
}
